import {
  DEAL_VIEW_PATH,
  HOME_PATH,
  SELECTION_ID_PATH,
  SELECTION_PATH
} from './constants.routes'
import HomeRopDesktop from 'pages/Desktop/Home/Rop/Home.rop.desktop'
import {
  MANAGER,
  MANAGER_AUTO_DAMU,
  ROP,
  ROP_CS,
  SPP,
  SUPER_HEAD_SALES
} from 'constants/roles'
import WorkListViewRopDesktop from '../pages/Desktop/WorkListView/Rop/WorkListView.rop.desktop'
import HomeManagerDesktop from '../pages/Desktop/Home/Manager/Home.manager.desktop'
import WorkListViewManagerDesktop from 'pages/Desktop/WorkListView/Manager/WorkListView.manager.desktop'
import SelectionMangerDesktop from 'pages/Desktop/Selection/Manager/Selection.manger.desktop'
import WorkListViewSppDesktop from 'pages/Desktop/WorkListView/SPP/WorkListView.spp.desktop'
import HomeSppDesktop from 'pages/Desktop/Home/SPP/Home.spp.desktop'

export const desktopRoutes = role => {
  const routesByRole = {
    [MANAGER]: [
      {
        path: HOME_PATH,
        component: HomeManagerDesktop,
        byRole: [MANAGER]
      }
    ],
    [MANAGER_AUTO_DAMU]: [
      {
        path: HOME_PATH,
        component: HomeManagerDesktop,
        byRole: [MANAGER_AUTO_DAMU]
      }
    ],
    [ROP]: [
      {
        path: HOME_PATH,
        component: HomeRopDesktop,
        byRole: [ROP]
      }
    ],
    [ROP_CS]: [
      {
        path: HOME_PATH,
        component: HomeRopDesktop,
        byRole: [ROP_CS]
      }
    ],
    [SUPER_HEAD_SALES]: [
      {
        path: HOME_PATH,
        component: HomeRopDesktop,
        byRole: [SUPER_HEAD_SALES]
      }
    ],
    [SPP]: [
      {
        path: HOME_PATH,
        component: HomeSppDesktop,
        byRole: [SPP]
      }
    ]
  }
  console.log('routesByRole', routesByRole[role])
  return routesByRole[role] || []
}

export const managerSubRoutes = [
  {
    path: `${HOME_PATH}${DEAL_VIEW_PATH}/:id`,
    component: WorkListViewManagerDesktop,
    byRole: [MANAGER, MANAGER_AUTO_DAMU]
  },
  {
    path: `${HOME_PATH}${SELECTION_ID_PATH}/:step`,
    component: SelectionMangerDesktop,
    byRole: [MANAGER, MANAGER_AUTO_DAMU]
  },
  {
    path: `${HOME_PATH}${SELECTION_PATH}/:step`,
    component: SelectionMangerDesktop,
    byRole: [MANAGER, MANAGER_AUTO_DAMU]
  }
]
export const ropSubRoutes = [
  {
    path: `${HOME_PATH}${DEAL_VIEW_PATH}/:id`,
    component: WorkListViewRopDesktop,
    byRole: [ROP, ROP_CS, SUPER_HEAD_SALES]
  }
]
export const sppSubRoutes = [
  {
    path: `${HOME_PATH}${DEAL_VIEW_PATH}/:id`,
    component: WorkListViewSppDesktop,
    byRole: [SPP]
  }
]
